






































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'

@Component
export default class ViewFinanceiroEspecialidade extends Vue {
  itemMode: string = 'CREATE'

  loadEditar: any = ''
  get loadingEditar() { return this.loadEditar }
  set loadingEditar(value: any) { this.loadEditar = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDelete: boolean = false
  get loadingDelete() { return this.loadDelete }
  set loadingDelete(value: boolean) { this.loadDelete = value }

  itemToDelete: any = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: any) { this.itemToDelete = value }

  modalDelete: boolean = false
  get showModalDelete() { return this.modalDelete }
  set showModalDelete(value: boolean) { this.modalDelete = value }

  get store() { return getModule(FinanceiroStore, this.$store) }

  get tableHeaders() {
    return [
      { text: 'Identificador', value: 'codigoUnico', align: 'left', sortable: false },
      { text: 'Descrição', value: 'descricao', align: 'left', sortable: false },
      { text: 'Hospital', value: 'hospitalId', align: 'left', sortable: false },
      { text: 'Cadastrado por', value: 'createdByNome', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsEspecialidade() { return this.store.itemsEspecialidade }

  nomeHospital(hospitalId: any) {
    if (!hospitalId) return 'Todos os hospitais'
    const hospital = this.store.fontePagadoras.find((h: any) => h.id === hospitalId)
    return hospital ? hospital.nome : '-'
  }

  get filtroDescricao() { return this.store.filtroDescricaoEspecialidade }
  set filtroDescricao(value: string) { this.store.setFiltroDescricaoEspecialidade(value || '') }

  get filtroCodigoUnico() { return this.store.filtroCodigoUnicoEspecialidade }
  set filtroCodigoUnico(value: string) { this.store.setFiltroCodigoUnicoEspecialidade(value || '') }

  get filtroHospitalId() { return this.store.filtroHospitalIdEspecialidade }
  set filtroHospitalId(value: string) { this.store.setFiltroHospitalIdEspecialidade(value || '') }

  criarItem() {
    this.itemMode = 'CREATE'
    this.store.clearItemEspecialidade()
    this.store.setModal({ name: 'criarEditarEspecialidade', value: true })
  }

  async editarItem(item: any) {
    this.itemMode = 'EDIT'
    this.store.clearItemEspecialidade()
    this.loadingEditar = item.id
    await timeout(500)
    this.store.setOriginalItemEspecialidade({ ...item })
    this.store.setItemEspecialidade({ ...item })
    this.store.setModal({ name: 'criarEditarEspecialidade', value: true })
    this.loadingEditar = ''
  }

  async apagarItem() {
    this.loadingDelete = true
    const response = await this.store.deleteEspecialidade(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Especialidade apagada com sucesso!`, icon: 'done', color: '#2E7D32' })
      this.showModalDelete = false
      await this.getAllItems()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || `Ocorreu um problema com essa requisição.`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDelete = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.store.getAllEspecialidade()
    this.loadingDataTable = false
  }

  setItemToDelete(id: any) {
    this.itemToDeleteId = id
    this.showModalDelete = true
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.store.clearItemsEspecialidade()
    this.store.clearItemEspecialidade()
    if (!this.store.fontePagadoras.length) await this.store.getFontePagadoraAll()
    await this.store.getAllEspecialidade()
    this.$ga.event('financeiro', 'acessar-especialidade', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() { await this.init() }

  get itemsLength() {
    return Math.ceil(this.store.itemsEspecialidadeTotal / this.store.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() { return this.store.itemsEspecialidadePagina }
  set getPagina(value: number) { this.store.setItemsEspecialidadePagina(value) }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.store.getAllEspecialidade()
    this.loadingDataTable = false
  }

  @Watch('showModalDelete')
  onChangeShowModalDelete(value) { if (!value) this.itemToDeleteId = '' }
}
